import { Button, Modal } from 'react-bootstrap';

import CTAButtonWrapper from '../CTAButtonWrapper';
import IconButtonWrapper from '../IconButtonWrapper';
import styles from './ModalWrapper.scss';

const ModalWrapper = (props) => {
  const {
    title,
    showClose = true,
    closeHandler,
    children,
    primary,
    secondary,
    showModal = true,
    footerChildren,
    className,
    restoreFocus = true,
  } = props;
  const dialogClassName = `${[styles['custom-modal-dialog'], className || ''].join(' ')}`;

  return (
    <>
      <Modal
        aria-label={title}
        aria-labelledby="modal-title"
        aria-describedby="modal-body"
        backdrop="static"
        show={showModal}
        centered
        onKeyDown={(e) => e.stopPropagation()}
        restoreFocus={restoreFocus}
        onHide={closeHandler}
        contentClassName={styles['custom-modal-dialog-content']}
        dialogClassName={dialogClassName}>
        <Modal.Header className={styles['custom-modal-header']}>
          <Modal.Title id="modal-title">
            <h1 className={styles['title']}>{title}</h1>
          </Modal.Title>
          {showClose && (
            <IconButtonWrapper
              icon="/resources/assets/ui/nextgen/close.svg"
              onClick={closeHandler}
              description="close button"
            />
          )}
        </Modal.Header>
        <Modal.Body id="modal-body" className={styles['body']}>
          {children}
        </Modal.Body>
        <Modal.Footer>
          {primary && primary.show && (
            <CTAButtonWrapper
              variant="primary"
              aria-label={primary.text}
              onClick={primary.onClick}
              tabIndex={0}
              disabled={primary.disabled}
              text={primary.text}
            />
          )}
          {secondary && secondary.show && (
            <CTAButtonWrapper
              variant="secondary"
              onClick={secondary.onClick}
              tabIndex={0}
              aria-label={secondary.text}
              disabled={secondary.disabled}
              text={secondary.text}
            />
          )}
          {footerChildren}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalWrapper;
